// import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
// import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';

function Tabs() {
  return (
    <Tab.Container id="list-group-tabs-example" defaultActiveKey="#planning">
      <div className="row p-lg-5 ms-lg-5 me-lg-5">
      <div className="col list-group ms-5 me-5 p-3 text-center" id="myList" role="tablist">
        <div className="text-primary text-left mt-5 mb-5"><span className='headText'>Our Services...</span></div>
          <ListGroup>
            <ListGroup.Item action href="#planning">
                Tax Planning
            </ListGroup.Item>
            <ListGroup.Item action href="#bookkeeping">
                Bookkeeping
            </ListGroup.Item>
            <ListGroup.Item action href="#structure">
                Company Structure
            </ListGroup.Item>
            <ListGroup.Item action href="#forms">
                Federal and State Forms
            </ListGroup.Item>
          </ListGroup>
        </div>
        <div className="col tab-content ms-5 me-5 p-3" style={{minHeight:'400px'}}>
          <Tab.Content>
            <Tab.Pane eventKey="#planning">
                <div className='headText'>Plan for your taxes before your business is off the ground.</div>
            </Tab.Pane>
            <Tab.Pane eventKey="#bookkeeping">
                <div className='headText'>We'll teach your company how to accurately keep records.</div>
            </Tab.Pane>
            <Tab.Pane eventKey="#structure">
                <div className='headText'>We'll help you decide what the best organization is for you.</div>
            </Tab.Pane>
            <Tab.Pane eventKey="#forms">
                <div className='headText'>We'll help you apply for all the tax IDs and forms you need.</div>
            </Tab.Pane>
          </Tab.Content>
        </div>
      </div>
    </Tab.Container>
  );
}

export default Tabs;

<div className="row p-5 ms-5 me-5">

    <div className="col list-group ms-5 me-5 p-3 text-left justify-content-center align-items-center" id="myList" role="tablist">
        <a className="list-group-item list-group-item-action active" data-bs-toggle="list" href="#home" role="tab">Tax Planning</a>
        <a className="list-group-item list-group-item-action" data-bs-toggle="list" href="#profile" role="tab">Bookkeeping</a>
        <a className="list-group-item list-group-item-action" data-bs-toggle="list" href="#messages" role="tab">Company Structure</a>
        <a className="list-group-item list-group-item-action" data-bs-toggle="list" href="#settings" role="tab">Federal and State Forms</a>
    </div>


    <div className="col tab-content ms-5 me-5 p-3">
        <div className="tab-pane display-4 text-right active" id="home" role="tabpanel">
            <div className="display-2 text-right text-primary">Our Services</div>
            Plan for your taxes before your business is off the ground.
        </div>
        <div className="tab-pane display-4 text-right fade" id="profile" role="tabpanel">
            <div className="display-2 text-right text-primary">Our Services</div>
            We'll teach your company how to accurately keep records.
        </div>
        <div className="tab-pane display-4 text-right fade" id="messages" role="tabpanel">
            <div className="display-2 text-right text-primary">Our Services</div>
            We'll help you decide what the best organization is for you.
        </div>
        <div className="tab-pane display-4 text-right fade" id="settings" role="tabpanel">
            <div className="display-2 text-right text-primary">Our Services</div>
            We'll help you apply for all the tax IDs and forms you need.
        </div>
    </div>
</div>